import { MdUpload } from "react-icons/md";
import { BsTrashFill } from "react-icons/bs";

import VideoContainer from "../Preview";

import { StyledLabel, DeleteDiv } from "./UploadVideo.style";

export default function UploadVideoCM(props) {
  return (
    <>
      <StyledLabel
        htmlFor={props.type + props.file?.id}
        refillable={props.refillable}
      >
        {props.isWeb ? (
          <VideoContainer
            isWeb
            width={props.width}
            height={props.height}
            src={props.file}
          />
        ) : props.isLocal ? (
          <VideoContainer
            width={props.width}
            height={props.height}
            src={URL.createObjectURL(props.file)}
          />
        ) : (
          <>
            <MdUpload size={22} />
            بارگذاری ویدیو جدید
          </>
        )}
        {props.onDelete && (
          <DeleteDiv onClick={props.onDelete}>
            <BsTrashFill />
          </DeleteDiv>
        )}
      </StyledLabel>

      <input
        id={props.type + props.file?.id}
        type="file"
        style={{ display: "none" }}
        onChange={(e) => props.onChange(e.target.files[0])}
        disabled={!props.refillable}
        accept="audio/*, video/*"
      />
    </>
  );
}
